import * as React from "react";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import "./HelpButton.scss";

export const HelpButton = (): JSX.Element => {
    const { drawingInfoVisible, setDrawingInfoVisible } = useRegistrationContext();
    return (
        <span
            className="help-button unselectable"
            onClick={() => setDrawingInfoVisible(drawingInfoVisible ? false : true)}
        >
            <span>?</span>
        </span>
    );
};
